<template>
  <VDataGridV2
    sticky
    :loader="loader"
    paginated
    entity-type="manufacturer"
    :context-menu="ManufacturersService.contextMenu"
    @row:dblclick="openCard"
  >
    <VDataGridColumnV2
      id="id"
      width="50px"
      label="id"
    >
      <template #default="{ row }">
        <div>
          <VLink
            @click="openCard(row)"
          >
            {{ row.id }}
          </VLink>
        </div>
        <div class="description">
          <VBadge
            v-if="row.isDeleted"
            class="warning"
          >
            Удалён
          </VBadge>
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="name"
      label="Название"
      width="500px"
      :filter="$core.filters.pattern"
      content-class="ellipsis"
    >
      <template #default="{ row }">
        <div class="ellipsis">
          {{ row.name }}
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridActionBarV2>
      <VButton
        theme="primary"
        @click="openCard()"
      >
        Создать производителя
      </VButton>
    </VDataGridActionBarV2>
  </VDataGridV2>
</template>

<script lang="ts">

import DataGridLoader          from '@/lib/components/VDataGridV2/DataGridLoader';
import Manufacturer            from '@/domains/Manufacturers/Manufacturer';
import ManufacturersService    from '@/domains/Manufacturers/ManufacturersService';

export default defineComponent({
  name: 'ManufacturersRegistry',

  setup() {
    return {
      ManufacturersService,
    };
  },

  data() {
    return {
      loader: new DataGridLoader(ManufacturersService.getListPaginated),
    };
  },

  methods: {
    async openCard(row?: Manufacturer): Promise<void> {
      if (await ManufacturersService.showCard(row ?? null) === true) {
        await this.loader.refresh();
      }
    },
  },
});
</script>